import React, { useState } from "react";

import { CircularProgress } from "@material-ui/core";

import { Button, useListContext, useNotify, useRefresh } from "react-admin";

import { ImportIcon } from "../../../components/common/iconography";

import { logError } from "../../../utils/appUtils";
import { hasExternalId } from "../../../utils/zapierUtils";

import { AccountImportDialog } from "./AccountImportDialog";
import {
  createAccountFromCustomer,
  updateAccountFromCustomer,
} from "./AccountUtils";

export const AccountImportButton = ({ disabled: disabledProp, ...props }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const { total } = useListContext();

  const handleClick = (event) => {
    setImportOpen(true);
  };

  // Import CSV customer rows: create new accounts or update matched ones (AppSync).
  // External accounting sync is not triggered from this button (see AccountSyncMenuButton for Zapier).
  const processImport = async (importedCustomers) => {
    debugger;
    try {
      setLoading(true);
      // do not sync already synced accounts
      const filteredCustomers = importedCustomers.filter(
        (c) => !hasExternalId(c),
      );

      for (const customer of filteredCustomers) {
        if (!customer.reloadYardId) {
          // Create missing accounts & log history
          await createAccountFromCustomer(customer);
        } else {
          // account matched
          await updateAccountFromCustomer(customer);
        }
      }
      notify && notify("Import request submitted.", "info");
    } catch (err) {
      logError("accounts:SuncMenuButton:processImport", err, notify);
    } finally {
      setLoading(false);
      refresh();
    }
  };

  return (
    <>
      <Button
        label="Import"
        onClick={handleClick}
        color="primary"
        size="small"
        disabled={disabledProp || total === 0}
      >
        {loading ? (
          <CircularProgress color="inherit" size={17} />
        ) : (
          <ImportIcon />
        )}
      </Button>

      {importOpen && (
        <AccountImportDialog
          total={total}
          isOpen={importOpen}
          setIsOpen={setImportOpen}
          handleImport={processImport}
        />
      )}
    </>
  );
};
